class WwdImage {
	constructor( $dom ){
		this.pos = [0, 0];
		this.dom = $dom;
		this.area = $dom.querySelector(".list_inner");
		this.target = $dom.querySelector(".img");
		this.nav();
	}
	nav(){
		this.area.removeEventListener("mousemove", this.getPos.bind(this), false);
		this.area.addEventListener("mousemove", this.getPos.bind(this), false);
	}
	getPos(e){
		const rect = this.area.getBoundingClientRect();
		
		let _x = e.clientX - rect.left;
		let _y = e.clientY - rect.top;
		let _h = this.target.clientHeight/-2;
		let _w = this.target.clientWidth/-2;
		this.target.style.transform = `translate3d(${_x + _w}px, ${_y + _h}px, 0)`;
		//console.log(e);
	}
}
export let wwdImages = {
	arry: [],
	init: function(){
		let $html = document.documentElement;
		if( $html.classList.contains("pc") ){
			let $lists = document.querySelectorAll("#wwd .c-list_content ul li");
			$lists.forEach( ($l, index) => {
				wwdImages.arry[index] = new WwdImage($l);
			});
		}
	}
}